import React, { useEffect } from "react";
import styles from "./index.module.css";
import ReportTableSessionOverview from "Reporting/Components/ReportTableSessionOverview";
import { useSessionOverview } from "./useSessionOverview";
import Loader from "shared/Loader";

export default function ReportTableListSessionOverview({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const { data, isLoading, isError, refetch } = useSessionOverview(filters);

  useEffect(() => {
    if (data) {
      setReportsLength(data.length || 0);

      const title = `Session Overview - ${filters.eventNames?.[0] || ""}`;

      setReportData?.({
        title: title,
        rows: data,
      });
    }
  }, [data]);

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger, refetch]);

  useEffect(() => {
    if (Array.isArray(data)) {
      setReportsLength?.(data.length || 0);
    }
  }, [data, setReportsLength]);

  if (isError) return <div>Something went wrong...</div>;
  if (isLoading) return <Loader />;
  if (!Array.isArray(data) || data.length === 0)
    return <div>No Reports Found</div>;

  return (
    <div className={styles.container}>
      <ReportTableSessionOverview sessions={data} />
    </div>
  );
}
